@use '../../../global/host-utils';

:host {
  display: inline-block;
}

button {
  cursor: pointer;
  border: none;
  padding: 0;
  width: 36px;
  height: 52px;
  background: inherit;

  .poi {
    position: absolute;
    width: 16px;
    height: 16px;
    margin-top: 12px;
    background: var(--secondary-color);
    border-radius: 50%;
  }

  * {
    color: var(--color-brand-foreground);
  }

  @include host-utils.ipl-font-bold-smaller;
  &.small {
    width: 24px;
    height: 35px;
    @include host-utils.ipl-font-copytext-extrasmall;

    .poi {
      position: absolute;
      width: 10px;
      height: 10px;
      margin-top: 7px;
      border-radius: 50%;
    }
  }

  .pin {
    fill: var(--primary-color);
    stroke: var(--color-brand-foreground);
  }

  &:hover .pin {
    fill: var(--secondary-color-accent);
  }

  &.activeState:not(:active),
  &:active {
    .pin {
      fill: var(--color-black);
    }

    * {
      color: #fff;
    }

    .poi {
      background: #fff;
    }
  }

  &:disabled {
    pointer-events: none;

    & * {
      color: var(--color-neutral-steel-400);
      fill: var(--color-steel-200);
      stroke: var(--color-brand-foreground);
    }

    .poi {
      background: var(--secondary-color);
    }
  }
}

.icon-wrapper,
.small .icon-wrapper {
  position: absolute;
  text-align: center;
  width: 36px;
  height: 24px;
  padding-top: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  .small & {
    width: 24px;
    height: 16px;
  }
}
